// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'iview'
import 'iview/dist/styles/iview.css' // 使用 CSS
import http from './util/http.js'

import axios from 'axios';
import "babel-polyfill";
Vue.prototype.$axios = axios
Vue.prototype.http = http
// axios.defaults.baseURL = 'http://192.168.1.222:8082/app-og/';//超洋服务器
// axios.defaults.baseURL = 'http://test.gzmoninet.com/app-og/'; //测试服务器
// axios.defaults.baseURL = 'http://api.gzmoninet.com/app-og/'; //正式服务器
axios.defaults.baseURL =  process.env.API_ROOT; //配置服务器

// 引用API文件
// import api from './api/index.js'   //axios封装
// 将API方法绑定到全局
// Vue.prototype.$api = api
// const Bus = new Vue()

Vue.config.productionTip = false
Vue.use(iView)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  components: { App },
  template: '<App/>',
  data:{
    // Bus
  }
})



// WEBPACK FOOTER //
// ./src/main.js